<template>
  <div>
    <BreadCrumd
      :title="'Configuration'"
      :description="'Liste des centres de coût'"
    />
    <div class="mt-2 mb-4">
      <div class="row">
        <div class="col-md-12 text-right">
          <button
            type="button"
            class="btn btn-secondary mr-4"
            @click.prevent="
              $router.push({ name: 'configuration_dic_home' }).catch(() => {})
            "
          >
            <i class="ion ion-md-cube"></i>
            Dictionnaire
          </button>

          <button type="button" class="btn btn-custom-primary" @click="create">
            <i class="fas fa-plus"></i>
            Nouveau centres de coût
          </button>

          <button
            type="button"
            class="btn btn-danger ml-4"
            @click.prevent="deleteAllSelection"
            v-show="isSelect"
          >
            <i class="fas fa-trash"></i>
            Supprimer
          </button>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12">
          <DataTable
            ref="datatable"
            :headers="headers"
            @onSelect="onSelectRows"
            @onRowShow="show"
            @onRowEdit="edit"
            @onRowsDelete="deleteRows"
          />
        </div>
      </div>
    </div>
    <Modal ref="modalCivilite" @onInit="init" />
  </div>
</template>

<script>
import DataTable from '../components/DataTable.vue';
import URL from '@/http/configuration/dictionnaire/centre-cout';
import Modal from '../components/Modal.vue';

export default {
  data() {
    return {
      title: 'Centres de coût',
      isSelect: false,
      headers: [
        {
          text: 'Centre de coût',
          align: 'start',
          sortable: true,
          value: 'nom',
        },
        {
          text: 'Statut',
          align: 'start',
          sortable: false,
          value: 'statut',
        },
        {
          text: 'Action',
          align: 'center',
          sortable: false,
          value: 'id',
        },
      ],
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  components: {
    DataTable,
    Modal,
  },
  methods: {
    init() {
      this.$refs.datatable.loadItems();
    },
    create() {
      this.$refs.modalCivilite.create();
    },
    show(id) {
      this.$refs.modalCivilite.show(id);
    },
    edit(id) {
      this.$refs.modalCivilite.edit(id);
    },
    onSelectRows(isSelect) {
      this.isSelect = isSelect;
    },
    deleteAllSelection() {
      this.deleteRows(this.$refs.datatable.idsRowsSelected);
    },
    deleteRows(ids) {
      if (ids && ids.length > 0) {
        this.showConfirmDelete().then((result) => {
          if (result.value) {
            window.axios
              .delete(URL.CENTRE_COUT, {
                params: {
                  ids: ids,
                },
              })
              .then((resp) => {
                this.showSimpleAlerte('top-end', 'success', resp.data.message);
                this.$refs.datatable.loadItems();
                this.isSelect = false;
              })
              .catch();
          }
        });
      }
    },
  },
};
</script>
